import React, {memo} from "react";
import ProductCard from "./ProductCard";

const RenderProducts = ({
  productList,
  compareProducts,
  isPackages,
  handleOnCompareChange,
  rebateIds,
}) => {
  return (
    <>
      {productList?.map((productDetail, index) => (
        <ProductCard
          key={productDetail.id}
          index={index}
          productDetail={productDetail}
          isPackages={isPackages}
          handleOnCompareChange={handleOnCompareChange}
          compareProducts={compareProducts}
          rebateIds={rebateIds}
        />
      ))}
    </>
  );
};

export default memo(RenderProducts);
